import { render, staticRenderFns } from "./Register.vue?vue&type=template&id=09c20f38&scoped=true"
import script from "./Register.vue?vue&type=script&lang=js"
export * from "./Register.vue?vue&type=script&lang=js"
import style0 from "./Register.vue?vue&type=style&index=0&id=09c20f38&prod&lang=scss&scoped=true"
import style1 from "./Register.vue?vue&type=style&index=1&id=09c20f38&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09c20f38",
  null
  
)

export default component.exports